/** @format */

import { axiosInstance } from '@common/application/context/Providers';
import { ApiResponse, AxiosApiResponse } from '@common/types/api';

export class Currency {
  name: string;
  iso4217: string;
  iconName: string;

  constructor(iso4217, iconName, name) {
    this.iso4217 = iso4217;
    this.iconName = iconName;
    this.name = name;
  }

  //fetch

  static list(): ApiResponse<Currency[]> {
    // Ensure this code is not ran by SSR!
    if (typeof window !== 'undefined') {
      return axiosInstance.get(`/api/v1/currencies`, {}).then((res) => ({ ...res.data }));
    }
    throw new Error();
  }

  static get(id: number): AxiosApiResponse<Currency> {
    return axiosInstance.get(`/api/v1/currencies/${id}`).then((res) => ({ ...res.data }));
  }

  static delete(id: number): Promise<Record<string, unknown>> {
    return axiosInstance.delete(`/api/v1/currencies/${id}`).then((res) => ({ ...res.data }));
  }

  static undelete(id: number): Promise<Record<string, unknown>> {
    return axiosInstance.post(`/api/v1/currencies/${id}/undelete`).then((res) => ({ ...res.data }));
  }

  static update(updatedCurrency: { name: string; companyId: number; logo: string }, id: number): Promise<Record<string, unknown>> {
    return axiosInstance.patch(`/api/v1/currencies/${id}`, { payload: updatedCurrency }).then((res) => ({ ...res.data }));
  }

  static getAddTemplate(): Promise<Record<string, unknown>> {
    return axiosInstance.get(`/api/v1/templates/currencies/add`, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  add(): Promise<Record<string, unknown>> {
    return axiosInstance
      .post(`/api/v1/currencies`, {
        payload: {
          name: this.name,
          iconName: this.iconName,
          iso4217: this.iso4217,
        },
      })
      .then((res) => ({ ...res.data }));
  }
}
